
import angular from 'angular';

angular.module('folkeuni').factory('EmployeeApi', function($http) {
    var self = this;
    var apiBase = '/api/shop/employees';
    
    self.relatedProductsGet = function(siteId, employeeId){
        return $http({
            method: 'get',
            url: apiBase + '/' + siteId + '/' + employeeId + '/products'
          });
    }

    return self;
});